;(function (define) {
    'use strict'
    define( 'es6ish-class/lib/extend',['require','exports','module'],function( require, exports, module ){
    	return function ( target, donor){
    		var key;

    		for( key in donor ){
                if( donor.hasOwnProperty( key ) ){
        			target[key] = donor[key];
                }
    		}
    		return target;
    	}
    });
})(typeof module === 'object' && module.exports && typeof define !== 'function'
    ? function (factory) { module.exports = factory(require, exports, module); }
    : define
);
